module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profile"
    }
  }, [_c('div', {
    attrs: {
      "id": "user-profile"
    }
  }, [_c('avatar', {
    attrs: {
      "id": "avatar",
      "src": _vm.profile.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "user-info"
    }
  }, [_c('div', {
    attrs: {
      "id": "user-info-upper"
    }
  }, [_c('h1', [_c('text-holder', {
    attrs: {
      "width": "190px",
      "height": "19px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.profile.name || _vm.profile.login) + "\n                    ")])], 1), _vm._v(" "), _c('h2', [_c('text-holder', {
    attrs: {
      "width": "100px",
      "height": "16px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.profile.login || _vm.profile.name) + "\n                    ")])], 1)]), _vm._v(" "), _vm._m(0)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "user-bio"
    }
  }, [_c('text-holder', {
    attrs: {
      "width": "20px",
      "height": "20px",
      "center": true
    }
  }, [_vm._v("\n            " + _vm._s(_vm.profile.bio) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "user-stats"
    }
  }, [_c('div', {
    staticClass: "stats-divider space-holder"
  }), _vm._v(" "), _c('div', {
    staticClass: "stats-block"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('text-holder', {
    attrs: {
      "width": "40px",
      "height": "20px",
      "center": true
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.profile.followers) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "stats-description"
  }, [_vm._v("Followers")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stats-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "stats-block"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('text-holder', {
    attrs: {
      "width": "40px",
      "height": "20px",
      "center": true
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.profile.public_repos) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "stats-description"
  }, [_vm._v("Public repos")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stats-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "stats-block"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('text-holder', {
    attrs: {
      "width": "40px",
      "height": "20px",
      "center": true
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.profile.following) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "stats-description"
  }, [_vm._v("Following")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stats-divider space-holder"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "view-repos"
    }
  }, [_c('router-link', {
    staticClass: "green-btn",
    attrs: {
      "to": {
        name: 'USER_REPO_LIST'
      }
    }
  }, [_vm._v("VIEW REPOSITORIES")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-info-lower"
    }
  }, [_c('div', {
    staticClass: "round-btn"
  }, [_vm._v("\n                    Follow\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22442771!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 455
// module chunks = 2